
import Vue from 'vue';
import { ValidationObserver, extend } from 'vee-validate';
import {
  required,
} from 'vee-validate/dist/rules';
import BackgroundImage from '@/components/BackgroundImage/index.vue';
import Button from '@/components/Button/index.vue';
import Card from '@/components/Card/index.vue';
import Heading from '@/components/Heading/index.vue';
import IconEmail from '@/components/Icons/Email/index.vue';
import Input from '@/components/InputWithValidation/index.vue';
import LogoAgrotools from '@/components/Logos/Agrotools/index.vue';
import LogoPrincipal from '@/components/Logos/Principal/index.vue';
import LogoPrograma from '@/components/Logos/Programa/index.vue';
import recoverPasswordService from '@/services/user/recover-password';
import { isBayer } from '@/utils';
import {
  ButtonLogin,
  ErrorMessage,
  Message,
  WrapperButton,
  MessageAlertAlt,
  WrapperInput,
  WrapperMain,
} from './styles';

extend('required', { ...required });

export default Vue.extend({
  components: {
    BackgroundImage,
    Button,
    ButtonLogin,
    Card,
    ErrorMessage,
    Heading,
    IconEmail,
    Input,
    LogoAgrotools,
    LogoPrincipal,
    LogoPrograma,
    Message,
    ValidationObserver,
    WrapperButton,
    WrapperInput,
    WrapperMain,
    MessageAlertAlt,
  },
  data() {
    return {
      isBayer: false,
      loading: false,
      recovered: false,
      email: '',
      error: '',
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.error = '';
      const stDns = process.env.VUE_APP_APPLICATION_DNS;

      const response = await recoverPasswordService({
        stEmail: this.email,
        stDns,
      });

      this.loading = false;

      if (response.hasErrors) {
        this.error = response.message;
        return;
      }

      this.recovered = true;
    },

    goToLogin() {
      this.$router.replace('/login');
    },
  },
  mounted() {
    this.isBayer = isBayer();
  },
});
